'use client';

import { clearAuthScopedQueryCache } from '@/lib/query/auth-query-cache';
import { useQueryClient } from '@tanstack/react-query';
import { useLayoutEffect, useRef } from 'react';

interface AuthQueryCacheSyncProps {
  currentUserId: string | null;
  isPending?: boolean;
}

export function AuthQueryCacheSync({
  currentUserId,
  isPending = false,
}: AuthQueryCacheSyncProps) {
  const queryClient = useQueryClient();
  const previousUserIdRef = useRef<string | null | undefined>(undefined);

  useLayoutEffect(() => {
    if (isPending) {
      return;
    }

    if (previousUserIdRef.current === undefined) {
      previousUserIdRef.current = currentUserId;
      return;
    }

    if (previousUserIdRef.current === currentUserId) {
      return;
    }

    previousUserIdRef.current = currentUserId;
    clearAuthScopedQueryCache(queryClient);
  }, [currentUserId, isPending, queryClient]);

  return null;
}
